import { defineMessages } from 'react-intl'

export default defineMessages({
  editRecipeTitle: {
    id: 'app.recipeEdition.title',
    defaultMessage: 'Edição de Receitas',
  },
})
